import * as React from "react";
import {useContext} from "react";
import {formatDate} from "../../../../../format";
import {ConfigContext} from "../../../context/ConfigContext";
import {Button, Icon} from "semantic-ui-react";

interface CompanyFetchInfo {
    companyId: string;
    companyName: string;
    lastFetched: string;
}

export function FileSystemWorkerHealth() {

    const context = useContext(ConfigContext);

    const [isLoading, setIsLoading] = React.useState(true);
    const [fileSystemWorkerHealth, setFileSystemWorkerHealth] = React.useState<any>(null);

    React.useEffect(() => {
        loadFileSystemWorkerHealth().then();
    }, []);

    async function loadFileSystemWorkerHealth() {
        setIsLoading(true);
        let response = await fetch('/fileSystemWorker/health');
        let data = await response.json();
        setFileSystemWorkerHealth(data);
        setIsLoading(false);
    }

    function toDateObj(str: string) {
        const cleaned = str.replace(/\[.*]$/, "");
        return new Date(cleaned);
    }

    function sortByLastFetched(a: CompanyFetchInfo, b: CompanyFetchInfo) {
        let dateA = toDateObj(a.lastFetched);
        let dateB = toDateObj(b.lastFetched);
        return dateB.getTime() - dateA.getTime();
    }

    function moveCurrentCompanyToTop(list: CompanyFetchInfo[]) {

        const index = list.findIndex(entry => entry.companyId === context.companyId);
        if (index === -1) return list;

        const [currentCompany] = list.splice(index, 1);
        list.unshift(currentCompany);
        return list;
    }

    function drawConfigsLastFetched() {

        let configsLastFetched: CompanyFetchInfo[] = fileSystemWorkerHealth?.configsLastFetched

        let sortedList: CompanyFetchInfo[] = moveCurrentCompanyToTop(
            Object.keys(configsLastFetched).map((key) => {
                let companyId = key;
                let companyName = configsLastFetched[key].first;
                let lastFetched = configsLastFetched[key].second;

                return {
                    companyId: companyId,
                    companyName: companyName,
                    lastFetched: lastFetched
                };
            }).sort(sortByLastFetched)
        );


        return sortedList.map((entry) => {

            let backgroundColor = entry.companyId === context.companyId ? "#e3f2fd" : "#fafafa";
            return (
                <div key={entry.companyId} style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "0.5em",
                    padding: "0.5em 1em",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    background: backgroundColor
                }}>
                    <span style={{color: "#1976d2", minWidth: "220px"}}>({entry.companyId})</span>
                    <strong style={{minWidth: "550px"}}>{entry.companyName}</strong>
                    <strong>Last Config Fetch:</strong>
                    <span style={{
                        color: "#388e3c",
                        minWidth: "150px",
                        textAlign: "right",
                        display: "inline-block"
                    }}>{formatDate(toDateObj(entry.lastFetched))}</span>
                </div>
            );
        });
    }

    return <>
        {isLoading ? <div>Loading...</div> :
            <div>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    //justifyContent: "space-between"
                }}>
                    <h2 style={{margin: 0}}>File System Worker Health</h2>
                    <Button
                        icon
                        style={{marginLeft: "1em", padding: "0.5em 1em", cursor: "pointer"}}
                        onClick={() => loadFileSystemWorkerHealth()}
                        disabled={isLoading}
                    >
                        <Icon name="refresh"/>
                    </Button>
                </div>
                {drawConfigsLastFetched()}
            </div>
        }
    </>

}